import { useMutation } from "@tanstack/react-query"

import { addQuests, deleteQuest, editQuests } from "./api"
import { queryClient } from "../../queryClient"
import { QueryKey } from "../../types/queries"

export const useAddQuestMutation = () => {
  return useMutation({
    mutationFn: addQuests,
    onSuccess: async (_data, variables) => {
      queryClient.invalidateQueries([QueryKey.COACH_TODOS])
      await queryClient.invalidateQueries([
        QueryKey.QUESTS,
        variables.questInfo.date,
      ])
    },
  })
}

export const useEditQuestMutation = () => {
  return useMutation({
    mutationFn: editQuests,
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKey.QUESTS])
    },
  })
}

export const useDeleteQuestMutation = () => {
  return useMutation({
    mutationFn: ({
      questSeriesId,
      date: _date,
    }: {
      questSeriesId: number
      date: string
    }) => deleteQuest(questSeriesId),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries([QueryKey.QUESTS, variables.date])
    },
  })
}
